import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { Link } from "react-router-dom";

export const faqItems = [
  {
    q: "Kto je Ján Kuráň?",
    a: "Ján Kuráň je Ružomberčan a kandidát na primátora mesta Ružomberok v komunálnych voľbách 2026, s volebným číslom 3.",
  },
  {
    q: "Na akú funkciu kandiduje a aké má volebné číslo?",
    a: "Kandiduje na primátora mesta Ružomberok v komunálnych voľbách 2026. Jeho volebné číslo je 3.",
  },
  {
    q: "Aké sú hlavné priority jeho programu?",
    a: "Dostupné bývanie, viac pracovných miest, funkčná MHD a doprava, živé centrum, transparentnosť a fungovanie mesta od základov.",
  },
  {
    q: "Čo navrhuje v oblasti bývania?",
    a: "Vytvoriť podmienky na vznik približne 1 000 nových bytov do roku 2036 kombináciou družstevného, nájomného a súkromného bývania.",
  },
  {
    q: "Kde si môžem stiahnuť celý program?",
    a: "Celý program je dostupný ako HTML na stránke /program a tiež na stiahnutie vo formáte PDF.",
  },
];

const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="bg-campaign-cream px-4 sm:px-6 py-16 sm:py-24 border-t-4 border-campaign-ink">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-display text-4xl sm:text-6xl text-campaign-ink leading-none uppercase mb-10">
          Najčastejšie otázky
        </h2>
        <div className="space-y-3">
          {faqItems.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-4 border-campaign-ink bg-campaign-yellow">
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 py-4"
                >
                  <span className="font-display text-campaign-ink uppercase text-base sm:text-lg">{f.q}</span>
                  {isOpen ? <Minus size={20} className="shrink-0" /> : <Plus size={20} className="shrink-0" />}
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-campaign-ink/85 leading-relaxed">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <p className="mt-8 text-campaign-ink/80">
          Celý volebný program nájdete na stránke{" "}
          <Link to="/program" className="font-semibold text-campaign-blue underline">Volebný program</Link>.
        </p>
      </div>
    </section>
  );
};

export default Faq;
